import { ActorRole } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export const editionModeState = atom<ActorRole | null>(null);
